import { PencilSimpleLine } from '@phosphor-icons/react'
import { useGetAppAgreements } from 'api/Agreements/Agreeements'
import CustomModal from 'components/global/CustomModal'
import CustomModalFooter from 'components/global/CustomModalFooter'
import Spinner from 'components/Spinner'
import React, { useEffect } from 'react'
import { AgreementResp } from 'types/agreement/agreement'

interface AppAgreementsProps {
  openModal: boolean
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>
  forApp: 'guardian' | 'mentor' | 'organizer'
  setForApp: React.Dispatch<React.SetStateAction<string | undefined>>
  setAddAgreementModal: React.Dispatch<React.SetStateAction<boolean>>
  setSelectedAgreement: React.Dispatch<React.SetStateAction<AgreementResp>>
}

const AppAgreementsModal: React.FC<AppAgreementsProps> = ({
  openModal,
  setOpenModal,
  forApp,
  setForApp,
  setAddAgreementModal,
  setSelectedAgreement,
}) => {
  const { data, isLoading, isFetching, refetch } = useGetAppAgreements({
    forApp,
  })

  const handleClose = () => {
    setOpenModal(false)
    setForApp(undefined)
  }

  const handleAddAgreement = () => {
    setAddAgreementModal(true)
    setOpenModal(false)
  }

  const EditAgreement = agreement => {
    setSelectedAgreement(agreement)
    setAddAgreementModal(true)
  }

  useEffect(() => {
    refetch()
  }, [forApp])

  return (
    <>
      <CustomModal
        openModal={openModal}
        isCloseModalCustom={true}
        closeModal={handleClose}
        title={'Add APP Agreement'}
        footer={
          <CustomModalFooter
            multibutton={true}
            btnAlignment="justify-center"
            btnText="Cancel,Add new agreement"
            closeModal={handleClose}
            onSubmit={handleAddAgreement}
          />
        }
      >
        {isLoading || isFetching ? (
          <div className="felx align-center justify-center py-40px">
            <Spinner />
          </div>
        ) : (
          <>
            {data.length ? (
              data.map((agreement: AgreementResp) => {
                return (
                  <div
                    key={agreement._id}
                    className="flex align-center justify-between py-20px px-20px border-1px radius-8 mb-16px gap-20px"
                  >
                    <p className="w-80p">{agreement.agreement}</p>
                    <PencilSimpleLine
                      size={20}
                      color="#000"
                      className="pointer"
                      onClick={() => EditAgreement(agreement)}
                    />
                  </div>
                )
              })
            ) : (
              <div className="flex align-center justify-center py-40px">
                <p>No agreements created</p>
              </div>
            )}
          </>
        )}
      </CustomModal>
    </>
  )
}

export default AppAgreementsModal
